import React from 'react';
import { connect } from "react-redux";
import {
    DatePicker,

} from 'office-ui-fabric-react';

import moment from "moment";

export class StartEndDateFilter extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div><DatePicker label='Start Date'
                className="one-line-150"
                value={
                    this.props.headerFilters[this.props.startDateField]
                        ? new Date(this.props.headerFilters[this.props.startDateField])
                        : new Date()
                }
                onSelectDate={(value) => {
                    this.props.updateStateCallback(
                        {
                            headerFilters: {
                                ...this.props.headerFilters,
                                [this.props.startDateField]: value,
                            },
                        },
                        () => {
                            this.props.fetch(this.props.searchBox, 0);
                        }
                    );
                }}
                formatDate={(date) => moment(date).format("MMM DD YYYY")}
                allowTextInput
            />

                <DatePicker label='End Date'
                    className="one-line-150"
                    value={
                        this.props.headerFilters[this.props.endDateField]
                            ? new Date(this.props.headerFilters[this.props.endDateField])
                            : new Date()
                    }
                    onSelectDate={(value) => {
                        this.props.updateStateCallback(
                            {
                                headerFilters: {
                                    ...this.props.headerFilters,
                                    [this.props.endDateField]: value,
                                },
                            },
                            () => {
                                this.props.fetch(this.props.searchBox, 0);
                            }
                        )
                    }}
                    formatDate={(date) => moment(date).format("MMM DD YYYY")}
                    allowTextInput
                />
            </div>
        );
    }
}

function mapStateToProps(state, own_props) {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(StartEndDateFilter);


// WEBPACK FOOTER //
// ./client/components/common/StartEndDateFilter.js